import styles from "./userName.module.scss";
import { EThemeType } from "redux/reducers";
import clsx from "clsx";
interface IProps {
  name?: string;
  email?: string;
  className?: string;
  threads?: boolean;
  sidebar?: boolean;
  theme?: EThemeType;
}

const getCharacters = ({ name, email }: IProps): string => {
  if (name) {
    const splittedName = name.trim().split(" ");
    if (splittedName.length >= 2) {
      return `${name.split(" ")[0].substring(0, 1)}${name
        .split(" ")[1]
        .substring(0, 1)}`;
    } else if (splittedName.length === 1 && splittedName[0].length > 0) {
      return splittedName[0][0];
    }
  }

  return email?.substring(0, 1) || "DU";
};

// export const UserName = (props: IProps) => {
//   return (
//     // <div className={`${styles.nameContainer} ${props.threads ? styles.threads : ""} ${props.className} ${props.sidebar && props.theme === 'light' ? styles.light : ""}
//     //     ${props.sidebar && props.theme === 'dark' ? styles.dark : ""}`}>
//     //   {getCharacters(props).toUpperCase()}
//     // </div>
//   );
// };

export const UserName = (props: IProps) => {
  const { threads, className } = props;

  return (
    <div
      className={clsx(
        styles.nameContainer,
        threads && styles.threads,
        // sidebar && theme === "light" && styles.light,
        // sidebar && theme === "dark" && styles.dark,
        className
      )}
    >
      {getCharacters(props).toUpperCase()}
    </div>
  );
};
